import InfiniteScroll from "react-infinite-scroll-component";
import { formatCurrency, getStatusColor } from "shared/lib/format";
import { TablePlaceholder } from "shared/ui/placeholders";
import CustomLoader from "shared/ui/loader";

const COLUMN_WIDTHS = {
  date: "30%",
  code: "20%",
  address: "30%",
  amount: "20%",
};

export default function HistoryTable({
  items,
  onEndReached,
  hasMore,
  loading,
}) {
  return (
    <div className="table-responsive-sm">
      <InfiniteScroll
        dataLength={items.length}
        next={onEndReached}
        hasMore={hasMore}
        scrollThreshold={0.9}
        loader={
          <div className="text-center p-2">
            <CustomLoader fontSize={32} />
          </div>
        }
      >
        <table className="table table-centered mb-0">
          <thead>
            <tr>
              <th className="text-center" style={{ width: COLUMN_WIDTHS.date }}>
                Огноо
              </th>

              <th
                className="text-center"
                style={{ width: COLUMN_WIDTHS.address }}
              >
                Хаяг
              </th>
              <th className="text-center" style={{ width: COLUMN_WIDTHS.code }}>
                Утас
              </th>
              <th className="text-center" style={{ width: COLUMN_WIDTHS.code }}>
                Төлбөр
              </th>
              <th
                className="text-center"
                style={{ width: COLUMN_WIDTHS.amount }}
              >
                Төлөв
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <TablePlaceholder count={6} />
            ) : (
              items.map((item) => (
                <tr key={item.id}>
                  <td className="text-center">{item.createdAt}</td>
                  <td className="text-center">
                    {item?.district?.name} {item.address}
                  </td>
                  <td className="text-center">{item.phone}</td>
                  <td className="text-center">
                    {formatCurrency(item.deliveryPrice)}
                  </td>
                  <td className="text-center">
                    <span className={getStatusColor(item?.statusId)}>
                      {item?.statusId === 2
                        ? "Шинэ"
                        : item?.statusName || "Тодорхойгүй"}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  );
}
